import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-photo-map-dialog',
  template: `
    <div class="photo-map-container">
      <div class="photo-map-header">
        <div class="photo-map-title">
          <mat-icon style="margin-right: 8px; color: #1a73e8;">place</mat-icon>
          Photo Location
        </div>
        <button mat-icon-button [mat-dialog-close]="true" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="photo-map-meta">
        <div class="photo-map-meta-left">
          <div class="photo-map-caption">{{ data.caption }}</div>
          <div class="photo-map-coords">{{ data.lat | number:'1.5-5' }}, {{ data.lng | number:'1.5-5' }}</div>
        </div>
        <a [href]="googleMapsLink" target="_blank" rel="noopener" mat-stroked-button color="primary">
          <mat-icon style="margin-right: 4px;">open_in_new</mat-icon>
          Open in Google Maps
        </a>
      </div>

      <div class="photo-map-image-wrapper">
        <img
          *ngIf="staticMapUrl"
          [src]="staticMapUrl"
          alt="Map showing photo location"
          class="photo-map-image"
          (error)="onMapError()"
        />
        <div *ngIf="loadError" class="photo-map-error">
          <mat-icon style="font-size: 32px; height: 32px; width: 32px; color: #999;">map</mat-icon>
          <span>Map failed to load</span>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .photo-map-container {
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #fff;
      overflow: hidden;
    }
    .photo-map-header {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 16px 10px;
    }
    .photo-map-title {
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 600;
      color: #333;
    }
    .photo-map-meta {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px 12px;
      border-bottom: 1px solid #e8e8e8;
    }
    .photo-map-meta-left {
      min-width: 0;
    }
    .photo-map-caption {
      font-size: 14px;
      color: #555;
      margin-bottom: 2px;
    }
    .photo-map-coords {
      font-size: 12px;
      color: #999;
      font-family: 'Roboto Mono', monospace;
    }
    .photo-map-image-wrapper {
      flex: 1;
      overflow-y: auto;
      margin: 12px 16px;
      border-radius: 10px;
      border: 1px solid #e0e0e0;
      background: #f5f5f5;
      min-height: 0;
    }
    .photo-map-image {
      width: 100%;
      display: block;
    }
    .photo-map-error {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      color: #999;
      font-size: 14px;
      min-height: 300px;
    }
  `]
})
export class PhotoMapDialogComponent implements OnInit {
  staticMapUrl: string = '';
  googleMapsLink: string = '';
  loadError = false;

  constructor(
    public dref: MatDialogRef<PhotoMapDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    const lat = Number(this.data.lat);
    const lng = Number(this.data.lng);

    this.googleMapsLink = `https://www.google.com/maps?q=${lat},${lng}`;

    this.staticMapUrl = `${environment.baseUrl}/rhAPI/staticmap?lat=${lat}&lng=${lng}&zoom=16&size=800x500`;
  }

  onMapError(): void {
    this.loadError = true;
  }
}
